import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui';

import cls from './InviteCard.module.css';
import { useInviteCard } from './useInviteCard';
import { ComboboxCustom } from '../../../../../components/newUI/Combobox/Combobox';
import { Icon } from '../../../../../components/newUI/Icon/Icon';
import { EmployersForSelect } from '../../../../AddProject/SecondStep/useSecondStep';
import { Roles } from '../../../../AddProject/types/types';
import { OpenedInviteCard } from '../../useProjectTeamInvite';

interface InviteCardProps {
    classes?: string;
    type: CardType | Roles;
    openedInviteCard: OpenedInviteCard;
    onOpenedInviteCardChange: (value: OpenedInviteCard) => void;
    employersList: EmployersForSelect[];
    onEmployersListSet: (value: string) => void;
    isDash?: boolean;
    closingCard: string;
    onSetClosingCard: (value: string | null) => void;
}

export enum CardType {
    MANAGER = 'manager',
    FOREMAN = 'foreman',
    PURCHASER = 'purchaser',
}

const CardIcon: Record<CardType, string> = {
    [CardType.MANAGER]: 'managerIcon',
    [CardType.FOREMAN]: 'foremanIcon',
    [CardType.PURCHASER]: 'purchaserIcon',
};

export const InviteCard = ({
    classes,
    type,
    openedInviteCard,
    onOpenedInviteCardChange,
    onEmployersListSet,
    employersList,
    isDash,
    onSetClosingCard,
    closingCard,
}: InviteCardProps) => {
    const { t } = useTranslation();
    const {
        isOpened,
        validateError,
        query,
        setQuery,
        selectedPerson,
        setSelectedPerson,
        onAddEmployer,
        animate,
        onOpenCard,
    } = useInviteCard(
        openedInviteCard,
        onOpenedInviteCardChange,
        type,
        employersList,
        isDash,
        onEmployersListSet,
        onSetClosingCard,
        closingCard
    );

    return (
        <div
            onClick={(event) => event.stopPropagation()}
            className={classNames(cls.InviteCard, [classes], {
                [cls.opened]: isOpened,
            })}
        >
            {isOpened ? (
                <div
                    className={classNames(cls.InviteBlock, {
                        [cls.OpenInviteBlock]: isOpened,
                        [cls.CloseInviteBlock]: !isOpened,
                    })}
                >
                    <h4 className={cls.InviteTitle}>
                        {t('ProjectTeam.ProjectTeamInvite.InviteCard.title')}
                    </h4>
                    <div className={cls.InviteBlockContent}>
                        <ComboboxCustom
                            isBottom={type === Roles.PURCHASER}
                            validateError={validateError}
                            query={query}
                            setQuery={setQuery}
                            selectedPerson={selectedPerson}
                            setSelectedPerson={setSelectedPerson}
                            employersList={employersList}
                            onEmployersListSet={onEmployersListSet}
                        />

                        <UiButton
                            onClick={onAddEmployer}
                            className={cls.buttonWrapper}
                            variant="icon"
                            startIcon={<Icon iconName="plus" color="#fff" />}
                        />
                    </div>
                </div>
            ) : (
                <div
                    className={classNames(cls.Content, {
                        [cls.animationContent]: animate,
                        [cls.OpenContentBlock]: !isOpened,
                        [cls.CloseContentBlock]: isOpened,
                    })}
                    onClick={onOpenCard}
                >
                    <Icon iconName={CardIcon[type]} />
                    <span className={cls.TextTitle}>
                        <Icon iconName="plus" color="#1094F7" />
                        {t('ProjectTeam.ProjectTeamInvite.InviteCard.AddBtn')}
                    </span>
                </div>
            )}
        </div>
    );
};
